import { createSlice } from "@reduxjs/toolkit";

const postsSlice = createSlice({
  name: "posts",
  initialState: {
    posts: [],
    loading: false,
    singlePost: [],
    comment: [],
    postsForTable: [],
    defaultpost: false,
    commentStatus: false,
    commentEdit:false,
    defaultPostId: 0,
    createPosts: false,
    commentLoading: false,
    error: null,
    meta: {},
    total: 0,
  },
  reducers: {
    fetchPostsRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    fetchPostsRequestForDashboard: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    fetchPostsSuccessForDashBoard: (state, action) => {
      state.loading = false;
      const { posts, meta } = action.payload;
      const { page } = meta;

      if (page === 1) {

        // state.posts = posts; // first page → reset
        state.posts = [...posts];
      } else {
        state.posts = [...state.posts, ...posts]; // append
      }
      state.defaultPostId = posts[0].id;
      state.meta = meta;
      state.total = meta.total;
      state.defaultpost = false;
    },
    fetchPostsSuccess: (state, action) => {
      state.loading = false;
      state.posts = action.payload.posts;
      state.meta = action.payload.meta;
    },
    fetchPostsSuccessForTable: (state, action) => {
      state.loading = false;
      state.posts = action.payload.posts;
      state.meta = action.payload.meta;
      state.postsForTable = action.payload.posts;
    },

    fetchPostsFailure: (state, action) => {
      state.loading = false;
    },
    togglePublishRequest: (state, action) => {
      state.loading = true;
    },
    
    togglePublishSuccess: (state, action) => {
      state.loading = false;
    },
    togglePublishFailure: (state, action) => {
      state.loading = false;
    },
    toggleUnpublishRequest: (state, action) => {
      state.loading = true;
    },
    toggleUnpublishSuccess: (state, action) => {
      state.loading = false;
    },
    toggleUnpublishFailure: (state, action) => {
      state.loading = false;
    },
    deletePostRequest: (state) => {
      state.loading = true;
    },
    deletePostSuccess: (state) => {
      state.loading = false;
    },
    deletePostFailure: (state) => {
      state.loading = false;
    },
    createPostRequest: (state, action) => {
      state.createPosts = true;
      state.loading = true;
    },
    createPostModal: (state, action) => {
      state.createPosts = true;
    },
    createPostModalCancel: (state, action) => {
      state.createPosts = false;
    },
    createPostSuccess: (state, action) => {
      state.loading = false;
      state.createPosts = false;
      state.error=null
    },
    createPostFailure: (state, action) => {
      state.error = action.payload;
    },
    fetchPostByIdRequest: (state, action) => {
      state.loading = true;
      state.defaultpost = true;
      state.error = null;
    },
    fetchPostByIdSuccess: (state, action) => {
      state.loading = false;
      state.defaultpost = false;
      state.posts = action.payload;
      state.singlePost = action.payload;
    },
    fetchPostByIdFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    UpdatePostRequest: (state) => {
      state.loading = true;
    },
    UpdatePostSuccess: (state, action) => {
      state.loading = false;
      state.createPosts = false;
      state.posts = action.payload;
    },
    UpdatePostFailure: (state, action) => {
      state.loading = false;
      state.createPosts = false;
    },
    togglePublishByIdRequest: (state, action) => {
      state.loading = true;
    },
    togglePublishByIdSuccess: (state, action) => {
      state.loading = false;
      state.posts = action.payload;
    },
    togglePublishByIdFailure: (state, action) => {
      state.loading = false;
    },
    toggleUnpublishByIdRequest: (state, action) => {
      state.loading = true;
    },
    toggleUnpublishByIdSuccess: (state, action) => {
      state.loading = false;
    },
    toggleUnpublishByIdFailure: (state, action) => {
      state.loading = false;
    },
    fetchPostByIdRequestForcontent: (state, action) => {
      state.loading = true;
      state.defaultpost = true;
    },
    fetchPostByIdSuccessForcontent: (state, action) => {
      state.loading = false;
      state.defaultpost = false;
      state.singlePost = action.payload;
    },
    fetchPostByIdFailureForcontent: (state, action) => {
      state.loading = false;
    },
    addCommentRequest: (state, action) => {
      state.commentLoading = true;
      state.commentStatus = true;
    },
    addCommentSuccess: (state, action) => {
      state.commentLoading = false;
      state.commentStatus = false;
      state.comment = action.payload.data;
    },
    addCommentFialure: (state, action) => {
      state.commentLoading = false;
      state.error = action.error;
    },
    editCommentRequest: (state, action) => {
      state.commentLoading = true;
      state.commentStatus = true;
      state.commentEdit=false;
    },
    editCommentSuccess: (state, action) => {
      state.commentLoading = false;
      state.commentStatus = false;
      state.commentEdit=true;
      state.comment = action.payload;
    },
    editCommentFialure: (state, action) => {
      state.commentLoading = false;
      state.error = action.error;
    },
    deleteCommentRequest: (state, action) => {
      state.commentLoading = true;
      state.commentStatus = true;
    },
    deleteCommentSuccess: (state, action) => {
      state.commentLoading = false;
      state.commentStatus = false;
      state.comment = action.payload;
    },
    deleteCommentFialure: (state, action) => {
      state.commentLoading = false;
      state.error = action.error;
    },
  },
});

export const {
  fetchPostsRequest,
  fetchPostsSuccess,
  fetchPostsSuccessForTable,
  fetchPostsFailure,
  resetPosts,
  fetchPostsRequestForDashboard,
  fetchPostsSuccessForDashBoard,
  togglePublishSuccess,
  togglePublishRequest,
  togglePublishFailure,
  toggleUnpublishFailure,
  toggleUnpublishRequest,
  toggleUnpublishSuccess,
  deletePostRequest,
  deletePostFailure,
  deletePostSuccess,
  createPostFailure,
  createPostRequest,
  createPostSuccess,
  createPostModal,
  createPostModalCancel,
  fetchPostByIdFailure,
  fetchPostByIdRequest,
  fetchPostByIdSuccess,
  UpdatePostFailure,
  UpdatePostRequest,
  UpdatePostSuccess,
  togglePublishByIdFailure,
  togglePublishByIdRequest,
  togglePublishByIdSuccess,
  toggleUnpublishByIdFailure,
  toggleUnpublishByIdRequest,
  toggleUnpublishByIdSuccess,
  fetchPostByIdFailureForcontent,
  fetchPostByIdSuccessForcontent,
  fetchPostByIdRequestForcontent,
  addCommentFialure,
  addCommentRequest,
  addCommentSuccess,
  deleteCommentFialure,
  deleteCommentRequest,
  deleteCommentSuccess,
  editCommentFialure,
  editCommentRequest,
  editCommentSuccess,
} = postsSlice.actions;

export default postsSlice.reducer;
